module.exports = __webpack_public_path__ + "static/media/prisma-2.ece73463.svg";